import { useSyncExternalStore } from 'react';

let open = false;
// A conversation someone outside the window asked it to show ("Ask about this meeting",
// FEA-139). The window consumes it and clears it, so a later plain reopen resumes as before.
let requestedConversationId: number | null = null;
// Sent as the conversation's first message when the window takes the request (FEA-139's inline
// ask field). Cleared with the request, so it is sent once and never on a later reopen.
let requestedMessage: string | null = null;
// Or left in the composer instead, for the user to edit and send (FEA-139's coach mark "Try").
// Nothing is sent for them. Cleared with the request, like the message.
let requestedDraft: string | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach(l => l());

export const chatOpenStore = {
	isOpen() {
		return open;
	},
	toggle() {
		open = !open;
		emit();
	},
	openChat() {
		open = true;
		emit();
	},
	openConversation(conversationId: number, message?: string, { draft = false } = {}) {
		requestedConversationId = conversationId;
		requestedMessage = draft ? null : (message ?? null);
		requestedDraft = draft ? (message ?? null) : null;
		open = true;
		emit();
	},
	requestedConversationId(): number | null {
		return requestedConversationId;
	},
	requestedMessage(): string | null {
		return requestedMessage;
	},
	requestedDraft(): string | null {
		return requestedDraft;
	},
	clearRequestedConversation() {
		if (requestedConversationId === null) return;
		requestedConversationId = null;
		requestedMessage = null;
		requestedDraft = null;
		emit();
	},
	close() {
		open = false;
		emit();
	},
	subscribe(cb: () => void): () => void {
		listeners.add(cb);
		return () => {
			listeners.delete(cb);
		};
	}
};

export function useChatOpen(): boolean {
	return useSyncExternalStore(chatOpenStore.subscribe, () => open);
}
